import React from 'react';
import { Button, Checkbox, Select } from 'antd';

export function buildFrontlineTab(context) {
  const {
    shouldShowPage,
    handleSaveSystemSettings,
    updateSystemSettings,
    systemSettings
  } = context;

  if (
    !shouldShowPage?.('前线队员设置')
    && !shouldShowPage?.('指挥系统设置')
    && !shouldShowPage?.('系统设置')
  ) {
    return null;
  }

  return {
    key: 'frontline_settings',
    label: '前线队员设置',
    children: (
      <div>
        <h3>前线队员设置</h3>
        <div style={{ marginBottom: 16 }}>
          <Button type="primary" onClick={handleSaveSystemSettings}>保存设置</Button>
          <Button style={{ marginLeft: 8 }} onClick={() => {
            updateSystemSettings(settings => ({
              ...settings,
              frontlineSettings: {
                defaultOnlineHours: 24,
                showRescueTargets: true,
                showTracks: true,
                showMembers: true,
                onlineHoursOptions: [1, 6, 12, 24, 48, 168],
                enableSmartFilter: false
              }
            }));
          }}>重置默认</Button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div>
            <h4>默认在线时间筛选 (小时)</h4>
            <Select
              value={systemSettings.frontlineSettings?.defaultOnlineHours || 24}
              onChange={value => updateSystemSettings(settings => ({
                ...settings,
                frontlineSettings: { ...(settings.frontlineSettings || {}), defaultOnlineHours: value }
              }))}
              style={{ width: '100%' }}
            >
              <Select.Option value={1}>1小时</Select.Option>
              <Select.Option value={6}>6小时</Select.Option>
              <Select.Option value={12}>12小时</Select.Option>
              <Select.Option value={24}>24小时</Select.Option>
              <Select.Option value={48}>48小时</Select.Option>
              <Select.Option value={168}>1周</Select.Option>
            </Select>
            <p style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
              设置Locus Map接口默认返回多少小时内在线的队员
            </p>
          </div>

          <div>
            <h4>显示内容控制</h4>
            <div style={{ marginBottom: 8 }}>
              <Checkbox
                checked={systemSettings.frontlineSettings?.showRescueTargets !== false}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  frontlineSettings: { ...(settings.frontlineSettings || {}), showRescueTargets: e.target.checked }
                }))}
              >
                显示救援目标
              </Checkbox>
            </div>
            <div style={{ marginBottom: 8 }}>
              <Checkbox
                checked={systemSettings.frontlineSettings?.showTracks !== false}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  frontlineSettings: { ...(settings.frontlineSettings || {}), showTracks: e.target.checked }
                }))}
              >
                显示轨迹数据
              </Checkbox>
            </div>
            <div style={{ marginBottom: 8 }}>
              <Checkbox
                checked={systemSettings.frontlineSettings?.showMembers !== false}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  frontlineSettings: { ...(settings.frontlineSettings || {}), showMembers: e.target.checked }
                }))}
              >
                显示队员位置
              </Checkbox>
            </div>
          </div>

          <div>
            <h4>智能筛选</h4>
            <Checkbox
              checked={systemSettings.frontlineSettings?.enableSmartFilter || false}
              onChange={e => updateSystemSettings(settings => ({
                ...settings,
                frontlineSettings: { ...(settings.frontlineSettings || {}), enableSmartFilter: e.target.checked }
              }))}
            >
              启用智能筛选
            </Checkbox>
            <p style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
              根据队员最后在线时间自动调整筛选范围
            </p>
          </div>

          <div>
            <h4>接口信息</h4>
            <div style={{ background: '#f5f5f5', padding: 12, borderRadius: 4 }}>
              <p style={{ margin: 0, fontSize: 12 }}>
                <strong>统一接口地址：</strong><br/>
                <code>https://zh.lqsos.cn/locus</code>
              </p>
              <p style={{ margin: '8px 0 0 0', fontSize: 12 }}>
                <strong>支持格式：</strong> KML, GPX, JSON
              </p>
              <p style={{ margin: '8px 0 0 0', fontSize: 12 }}>
                <strong>谷歌地球：</strong><br/>
                请到「工具管理」中设置名称、说明和可见权限组，用户在「工具下载」页获取。<br/>
                <a href="/api/kml-export/google-earth">下载 ZHXT_GoogleEarth.kml</a>
                <br/>用谷歌地球电脑版打开，可勾选队员、救援目标、画板轨迹、路网、等高线。
              </p>
              <p style={{ margin: '8px 0 0 0', fontSize: 12 }}>
                <strong>当前配置：</strong><br/>
                在线时间：{systemSettings.frontlineSettings?.defaultOnlineHours || 24}小时<br/>
                救援目标：{systemSettings.frontlineSettings?.showRescueTargets !== false ? '显示' : '隐藏'}<br/>
                轨迹数据：{systemSettings.frontlineSettings?.showTracks !== false ? '显示' : '隐藏'}<br/>
                队员位置：{systemSettings.frontlineSettings?.showMembers !== false ? '显示' : '隐藏'}
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  };
}
